import "./OperatorUtilizationKpiCard.scss";

const icons = {
  users: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  activity: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  production: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 21V10l6 3V9l6 3V4h6v17H3Z" />
      <path d="M7 17h2M12 17h2M17 17h2" />
    </svg>
  ),
  quality: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  reject: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="m9 9 6 6M15 9l-6 6" />
    </svg>
  ),
};

function OperatorUtilizationKpiCard({
  eyebrow,
  label,
  value,
  detail,
  tone = "blue",
  icon = "activity",
  delay = 0,
}) {
  return (
    <article
      className={`operator-kpi-card operator-kpi-card--${tone}`}
      style={{ "--operator-kpi-delay": `${delay}ms` }}
    >
      <div className="operator-kpi-card__top">
        <span className="operator-kpi-card__eyebrow">{eyebrow}</span>
        <span className="operator-kpi-card__icon">{icons[icon] || icons.activity}</span>
      </div>

      <span className="operator-kpi-card__label">{label}</span>
      <strong>{value}</strong>
      <small>{detail}</small>

      <span className="operator-kpi-card__glow" />
    </article>
  );
}

export default OperatorUtilizationKpiCard;
